<div class="parent-div" (click)="toggleSort()" [ngStyle]="{'justify-content': center ? 'center' : ''}">
    <span>{{text}}</span>
    <div class="image-container" [ngClass]="{'no-opacity': !active}">
        <img [ngClass]="{'down-arrow': (direction === 'desc')}" [src]="'./assets/icons/up-arrow.svg'" alt="Arrow" />
    </div>
</div>